// extracted by mini-css-extract-plugin
export default {"inputStyle":"code-input_inputStyle__uVgM1","error":"code-input_error__kz29B"};